/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type PhoneCallStepPriority = typeof PhoneCallStepPriority[keyof typeof PhoneCallStepPriority];


export const PhoneCallStepPriority = {
  urgent: 'urgent',
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;
